import * as Styled from './Drawer.styles';

import { Divider } from '@mui/material';
import { useSelectCurveManager } from '../../../selectors';
import React from 'react';
interface Props {
	children: React.ReactNode;
	drawerId: string;
	title?: string;
	footer?: React.ReactNode;
	onClickAway?: () => void;
}

/**
 * Opens if passed drawerId === the drawer string in redux state
 */
const Drawer = ({ children, drawerId, title, footer, onClickAway }: Props) => {
	const selectedCurveManager = useSelectCurveManager();

	const handleClickAway = () => {
		if (onClickAway) onClickAway();
	};

	return (
		<Styled.Drawer
			anchor="right"
			open={selectedCurveManager.dialog === drawerId}
			classes={{ paper: 'innovyze-drawer-paper' }}
			ModalProps={{ onBackdropClick: handleClickAway }}>
			{title && (
				<>
					<Styled.Title
						color="primary"
						variant="heading-medium-strong">
						{title}
					</Styled.Title>
					<Divider />
				</>
			)}
			<Styled.DrawerBody data-cy="sideBar">{children}</Styled.DrawerBody>
			{footer && (
				<>
					<Divider />
					{footer}
				</>
			)}
		</Styled.Drawer>
	);
};

//Default Props
Drawer.defaultProps = {
	open: false,
	workspace: {
		id: 0,
		name: '',
		description: '',
	},
	workspaceErrors: [],
};

export default Drawer;
